import {
  GET_RESOURCE,
  GET_RESOURCES,
  DELETE_RESOURCE,
  RESOURCES_LOADED_FAIL,
  RESOURCE_LOADED_SUCCESS,
  RESOURCE_LOADED_FAIL,
  RESOURCES_LOADED_SUCCESS,
  RESOURCES_SEARCH_SUCCESS
} from '../constants/constants'

export const ResourceReducer = (state, action) => {
  const { type, payload } = action
  switch (type) {
    case DELETE_RESOURCE:
      return {
        ...state,
        resources: state.resources.filter(
          (resource) => resource._id !== payload
        )
      }
    case RESOURCES_SEARCH_SUCCESS:
      return {
        ...state,
        resourcesSearch: payload,
        resourcesLoading: false
      }
    case RESOURCES_LOADED_SUCCESS:
      return {
        ...state,
        resources: payload,
        resourcesLoading: false
      }
    case RESOURCES_LOADED_FAIL:
      return {
        ...state,
        resources: [],
        resourcesLoading: false
      }

    case GET_RESOURCES:
      return [...state, payload.resources]

    case RESOURCE_LOADED_SUCCESS:
      return {
        ...state,
        resource: payload,
        resourceLoading: false
      }
    case RESOURCE_LOADED_FAIL:
      return {
        ...state,
        resource: [],
        resourceLoading: false
      }

    case GET_RESOURCE:
      return [...state, payload.resource]

    default:
      return state
  }
}
